import * as XLSX from "xlsx";
import constant from "@/util/constant";
import store from "@/store";
import {axiosInstance} from "@/util/AxiosModule";

const getToday = function getToday() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return year + "-" + month + "-" + day;
};

const showAlert = function (message, callbackFunc = () => {}) {
  store.dispatch("alert/showAlert", {
    message: message,
    successCallback: () => {callbackFunc()}
  })
};

// 성별 이름 변환
const setSexNm = function setSexNm(sex) {
  if (!sex) return "";
  return constant.SEX_LIST.find(item => item.sex === sex).sexNm;
};

/**
 * 엑셀 추출
 * @param excelData {Object} 추출내용
 * @param sheetName {string} 시트 이름
 * @param fileName {string} 파일명
 */
function extractExcelFile(excelData, sheetName, fileName) {
  const json2sheet = XLSX.utils.json_to_sheet(excelData);

  const board = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(board, json2sheet, sheetName);
  XLSX.writeFile(board, fileName + `.xlsx`);
}

/**
 * 조직목록 조회
 * @param orgCd {string} 조직코드
 * @param useYn {string} 조직 사용여부
 * @param userYn {string} 조직 내 유저 조회여부
 * @param role {string} 조직 내 유저 권한 조회
 * @returns {Promise<any>}
 */
const getOrgList = async function (orgCd, useYn, userYn, role) {
  try {
    const { data } = await axiosInstance.get("/private/org/org-list", {
      params: {
        orgCd: orgCd,
        useYn: useYn,
        userYn: userYn,
        role: role
      }
    });
    return data;
  } catch (error) {
    await this.showAlert({message: `${error.response.data.message}`});
  }

}

export default {
  setSexNm,
  getToday,
  showAlert,
  extractExcelFile,
  getOrgList
}
